import 'array-from-polyfill'
import 'object-assign-polyfill'
import MicroModal from 'micromodal'

/**
 * Inits the modal.
 *
 * Docs: https://micromodal.now.sh/
 */
export default function modal() {
  if ( !document.querySelector( '.js-modal' ) ) {
    return
  }

  MicroModal.init({
    awaitCloseAnimation: true,
    onShow: onShow,
    disableScroll: true
  })

  /**
   * Mobile modal behaviour.
   * Refer to DSM for specs.
   *
   * @param {Element} modal The modal node.
   * @param {Element} element The element node.
   * @param {Event} event The event.
   */
  function onShow( modal, element, event ) {
    event.preventDefault()
    event.stopPropagation()
    const content = modal.querySelector( '.js-modal-container' )
    const innerContent = modal.querySelector( '.js-modal-inner-container' )
    const overlay = modal.querySelector( '.js-modal-overlay' )

    // Maximum 90% height of the screen.
    if ( content.clientHeight > window.innerHeight - ( window.innerHeight / 10 ) ) {
      overlay.classList.remove( 'items-end' )
      content.classList.add( 'mt-4' )
      innerContent.classList.add( 'overflow-y-scroll' )
    }
  }
}
